export enum GenderEnum {
	FEMALE = 'female',
	MALE = 'male',
	EMPTY = ''
}
